import { ReactNode } from 'react';

import {
  Modal,
  ModalContentBody,
  ModalContentHead,
  ModalContentWrapper,
  ModalFooter,
} from '@rrexpress/core';

export type ModalProviderRendererProps = {
  isOpen: boolean,
  title: string,
  template: ReactNode,
  footer?: ReactNode,
  width?: number,
  onClose: () => void,
};

export function ModalProviderRenderer({
  isOpen,
  title,
  template,
  footer,
  onClose,
  width,
}: ModalProviderRendererProps) {
  return (
    <Modal open={isOpen} onClose={onClose} width={width}>
      <ModalContentWrapper>
        <ModalContentHead title={title} onClose={onClose} />
        <ModalContentBody>
          {template}
        </ModalContentBody>
        {footer && (
          <ModalFooter>
            {footer}
          </ModalFooter>
        )}
      </ModalContentWrapper>
    </Modal>
  );
}
